import { blockInternal, requiresAuth, requiresTerms } from "@/middleware";

const OrganizationSeatsProductsView = () => import("./OrganizationSeatsProductsView.vue");

const organizationRoutes = [
  {
    path: "/organizations/:organizationId/seats-products/:productId?",
    name: "OrganizationSeatsProducts",
    component: OrganizationSeatsProductsView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal]
    }
  }
];

export default organizationRoutes;
